class XminionsFunctions {
  constructor() {
    this.windowWidth = window.innerWidth;
  }

  init() {
    new CustomSlideUp();

    gsap.registerPlugin(ScrollTrigger); 

    this.updateWindowWidthDom();
    window.addEventListener("resize", () => this.updateWindowWidthDom());

    // TODO: x-minions-header
    this.xMinionsHeader();

    // TODO: x-minions-collection
    this.xMinionsCollection();

    // TODO: x-minions-reveal
    this.xMinionsReveal();

    // TODO: x-minions-choose
    this.xMinionsChoose();

    // TODO: x-minions-unlocked
    this.xMinionsUnlocked();

    // TODO: x-minions-sofa
    this.xMinionsSofa();

    // TODO: x-minions-unveil
    this.xMinionsUnveil();

    // TODO: x-minions-ecosystem
    this.xMinionsEcosystem();
  }

  xMinionsHeader() {
    if (this.windowWidth >= 768) { 
      new Swiper('.xminions-pc-swiper', {
        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        },
        loop: true,
        effect: "fade",
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    }

    if (this.windowWidth <= 768) {
      const boxBg = document.querySelector('#x-minions-header-m');

      const updateMobileHeader = (swiper) => {
        const slide = swiper.slides[swiper.realIndex];

        const bg = slide?.getAttribute('data-bg-mb');

        if (bg) boxBg.style.backgroundImage = `url(${bg})`;

        boxBg.classList.toggle('is-last-slide', swiper.realIndex === swiper.slides.length - 1);
      };

      new Swiper('.xminions-header-swiper', {
        slidesPerView: 1.1,
        spaceBetween: 0,
        slidesOffsetAfter: 24,
        autoplay: true,

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        on: {
          init: updateMobileHeader,
          slideChangeTransitionEnd: updateMobileHeader,
        },
      });
    }
  }

  xMinionsCollection() {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      trigger: '#x-minions-collection',
      start: 'top top',
      end: 'bottom top',
      toggleClass: {
        targets: ".image-wrapper",
        className: "active"
      },
    });
  }

  xMinionsReveal() {
    if(this.windowWidth >= 768) {
      gsap.registerPlugin(ScrollTrigger);

      ScrollTrigger.create({
        trigger: '#x-minions-reveal',
        start: 'top-=250 top',
        end: 'bottom top',
        toggleClass: {
          targets: ".card-item-1",
          className: "active"
        },
      });

      ScrollTrigger.create({
        trigger: '#x-minions-reveal',
        start: 'top+=150 top',
        end: 'bottom top',
        toggleClass: {
          targets: ".card-item-2",
          className: "active"
        },
      });
    }
  }

  swiperInit(sp, prev, next) {
    const window_width = window.innerWidth;

    let slidesPerView, spaceBetween, slidesOffsetAfter;

    if (window_width <= 768) {
      slidesPerView = 1.1;
      spaceBetween = 16;
      slidesOffsetAfter = 24;
    } else {
      slidesPerView = 2.8;
      spaceBetween = 20;
      slidesOffsetAfter = 24;
    }
    
    return new Swiper(sp, {
      slidesPerView,
      spaceBetween,
      slidesOffsetAfter,
      loop: true,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });
  }

  gsapInitFunction(trigger, toggle1, toggle2) {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      trigger: trigger,
      start: 'top-=280 top',
      end: 'bottom top',
      toggleClass: {
        targets: toggle1,
        className: "active"
      },
    });

    ScrollTrigger.create({
      trigger: trigger,
      start: 'top-=280 top',
      end: 'bottom top',
      toggleClass: {
        targets: toggle2,
        className: "active"
      },
    });
  }

  xMinionsChoose() {
    const tabBoxDom = document.querySelector('#x-minions-choose .tabs-box');
    const tabsDom = document.querySelectorAll('#x-minions-choose .tabs'); 
    const editionDoms = document.querySelectorAll('#x-minions-choose .edition'); 
    const detailDoms = document.querySelectorAll('#x-minions-choose .detail-info');
    const swiperInstances = [];
    
    // TABS
    if (tabBoxDom) {
      tabBoxDom.addEventListener('click', function(e) {
        const target = e.target.closest('.tabs');

        if(target) {
          const edition = target.dataset.edition;

          // const detail = target.dataset.detail;

          tabsDom.forEach(function(tab) {
            tab.classList.remove('active');
          });

          editionDoms.forEach(function(edition) {
            edition.classList.remove('active');
          });

          // Swiper Hide
          // detailDoms.forEach(function(detail) {
          //   detail.classList.remove('active');
          // });

          target.classList.add('active');

          document.querySelector(`#x-minions-choose .${edition}`).classList.add('active');

          // Swiper Show
          // document.querySelector(`#x-minions-choose .${detail}`).classList.add('active');

          const slideIndex = edition === 'edition-2' ? 3 : 6;
          swiperInstances.forEach(function(instance) {
            instance.update();
            if (instance.params.loop) {
              instance.slideToLoop(slideIndex);
            } else {
              instance.slideTo(slideIndex);
            }
          });
        }
      });
    }
    
    // SWIPER
    detailDoms.forEach((detailDom) => {
      const swiperDom = detailDom.querySelector('.swiper');
      if (!swiperDom) return;

      const idxClass = Array.from(detailDom.classList).find(function(cls) {
        return cls.indexOf('detail-info-') === 0;
      });

      if (!idxClass) return;
      const idx = idxClass.replace('detail-info-', '');

      const instance = this.swiperInit('.swiper-minions-support-' + idx, '#btn-prev-minions-support-' + idx, '#btn-next-minions-support-' + idx);

      if (instance) swiperInstances.push(instance);
    });

    // GSAP
    if(this.windowWidth >= 768) {
      this.gsapInitFunction('#x-minions-choose', '#x-minions-choose .product-img', '#x-minions-choose .edition-info-box');
    }
  }

  xMinionsUnlocked() {
    gsap.registerPlugin(ScrollTrigger);

    if(window.innerWidth >= 768) {
      ScrollTrigger.create({
        trigger: '#x-minions-unlocked',
        start: 'top-=280 top',
        end: 'bottom top',
        toggleClass: {
          targets: ".left-image-item",
          className: "active"
        },
      });
  
      ScrollTrigger.create({
        trigger: '#x-minions-unlocked',
        start: 'top top',
        end: 'bottom top',
        toggleClass: {
          targets: ".right-image-item",
          className: "active"
        },
      });
    } else {
      ScrollTrigger.create({
        trigger: '#x-minions-unlocked .left-image-item',
        start: 'top 80%',
        end: 'bottom top',
        toggleClass: {
          targets: "#x-minions-unlocked .left-image-item",
          className: "active"
        }
      });
  
      ScrollTrigger.create({
        trigger: '#x-minions-unlocked .right-image-item',
        start: 'top 80%',
        end: 'bottom top',
        toggleClass: {
          targets: "#x-minions-unlocked .right-image-item",
          className: "active"
        }
      });
    }
  }

  xMinionsSofa() {
    const sofaDetailDoms = document.querySelectorAll('#x-minions-sofa .detail-info');
    const sofaswiperInstances = [];
    
    // SWIPER
    sofaDetailDoms.forEach((detailDom) => {
      const swiperDom = detailDom.querySelector('.swiper');
      if (!swiperDom) return;

      const idxClass = Array.from(detailDom.classList).find(function(cls) {
        return cls.indexOf('detail-info-') === 0;
      });

      if (!idxClass) return;
      const idx = idxClass.replace('detail-info-', '');

      const instance = this.swiperInit('.swiper-minions-sofa-support-' + idx, '#btn-prev-minions-sofa-support-' + idx, '#btn-next-minions-sofa-support-' + idx);

      if (instance) sofaswiperInstances.push(instance);
    });

    // SOFA BTN
    const sofaBtns = document.querySelectorAll('#x-minions-sofa .sofa-btn');
    sofaBtns.forEach(function (sofaBtn) {
      sofaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const imageBox = sofaBtn.closest('.product-img-box');
        if (!imageBox) return;

        const frontImage = imageBox.querySelector('#x-minions-sofa .product-img');
        const rearImage = imageBox.querySelector('#x-minions-sofa .product-img-rear');
        if (!frontImage || !rearImage) return;

        const isRearVisible = rearImage.style.display === 'block';
        frontImage.style.display = isRearVisible ? 'block' : 'none';
        rearImage.style.display = isRearVisible ? 'none' : 'block';
        imageBox.classList.toggle('active', !isRearVisible);
      });
    });

    // GSAP
    if(this.windowWidth >= 768) {
      this.gsapInitFunction('#x-minions-sofa', '#x-minions-sofa .product-img-wrap', '#x-minions-sofa .edition-info-box');
    }
  }

  xMinionsUnveil() {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      trigger: '#x-minions-unveiled',
      start: 'top-=280 top',
      end: 'bottom top',
      toggleClass: {
        targets: ".left-image-item",
        className: "active"
      },
    });

    ScrollTrigger.create({
      trigger: '#x-minions-unveiled',
      start: 'top top',
      end: 'bottom top',
      toggleClass: {
        targets: ".right-image-item",
        className: "active"
      },
    });
  }

  xMinionsEcosystem() {
    // GSAP
    if (this.windowWidth >= 768) {
      this.gsapInitFunction('#x-minions-ecosystem', '#x-minions-ecosystem .left', '#x-minions-ecosystem .right');

      const section = document.querySelector('#x-minions-ecosystem');
      const buttonEle = section.querySelector('.cart-box');

      buttonEle.addEventListener('click', function (e) {
        const target = e.target;
        const targetBtn = target.closest('.cart-item');

        if (!targetBtn || targetBtn.classList.contains('active')) return;

        const id = targetBtn.dataset.id;

        const targetEle = section.querySelectorAll(`[data-id="${id}"]`);

        section.querySelectorAll('[data-id].active').forEach(el => el.classList.remove('active'));

        targetEle.forEach(item => {
          item.classList.add('active');
        });
      })
    }
  }
}

XminionsFunctions.prototype.updateWindowWidthDom = function () {
  const el = document.getElementById("js-window-width");
  if (!el) return;
  el.textContent = `${window.innerWidth}`;
};
